import { DBDef_AIPrompt } from '@nu-art/prompting-shared';
import { ThunderDispatcherV3 } from '@nu-art/thunderstorm-frontend/core/db-api-gen/types';
import { ModuleFE_BaseApi } from '@nu-art/thunderstorm-frontend/index';
export const dispatch_onAIPromptsUpdated = new ThunderDispatcherV3('__onAIPromptsUpdated');
export class ModuleFE_AIPrompt_Class extends ModuleFE_BaseApi {
    _v1;
    constructor() {
        super(DBDef_AIPrompt, dispatch_onAIPromptsUpdated);
        this._v1 = {};
    }
}
export const ModuleFE_AIPrompt = new ModuleFE_AIPrompt_Class();
//# sourceMappingURL=ModuleFE_AIPrompt.js.map